module.exports = __webpack_public_path__ + "static/media/2021 - 2022 theme logo.186cb1fb.jpg";